/* eslint-disable */
export interface INumberFormatter {
  format(value: number, decimalPrecision?: number): string;
}

const NumberFormatter = (): INumberFormatter => {
  return {
    format(value: number | string, decimalPrecision?: number) {
      if (decimalPrecision) {
        value = parseFloat(value.toString()).toFixed(decimalPrecision);
      }
      return value.toString().replace(/\./gi, ",");
    }
  };
};

export default NumberFormatter;
